import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import deTranslation from '../locales/de/translation.json';
import enTranslation from '../locales/en/translation.json';
import frTranslation from '../locales/fr/translation.json';

const resources = {
    de: {
        translation: deTranslation
    },
    en: {
        translation: enTranslation
    },
    fr: {
        translation: frTranslation
    }
};

function initI18n(lng: string) {
    i18n
        .use(initReactI18next)
        .init({
            resources,
            lng: lng,
            interpolation: {
                escapeValue: false
            }
        });
}

export default initI18n;